import { ChainId } from '@shared/utils/config/networks';
import { wBTCAddresses, ChainLinkAddresses, EthAddresses, StableTokenAddresses } from '@/hooks/explore/tokenAddresses';
// Constants
export const SOLANA_NATIVE_ADDRESS = 'So11111111111111111111111111111111111111112';
export const SOLANA_NATIVE_SIMPLE = '11111111111111111111111111111111';
export const NATIVE_ADDRESS = '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee'; // Replace with actual NATIVE_ADDRESS
export const defaultAddress = '0x0000000000000000000000000000000000000000';
// Address mappings for different chains
export const addressMappings = {
  [ChainId.ETHEREUM]: {
    address: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
    subTitle: 'ETH'
  },
  [ChainId.BASE]: {
    address: '0x4200000000000000000000000000000000000006',
    subTitle: 'ETH'
  },
  [ChainId.ARBITRUM]: {
    address: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
    subTitle: 'ETH'
  },
  [ChainId.OPTIMISM]: {
    address: '0x4200000000000000000000000000000000000006',
    subTitle: 'ETH'
  },
  [ChainId.POLYGON]: {
    address: '0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270',
    subTitle: 'POL'
  },
  [ChainId.BSC]: {
    address: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
    subTitle: 'BNB'
  },
  '43114': {
    address: '0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7',
    subTitle: 'AVAX'
  }
};
/**
 * Transforms address based on input and mappings
 * @param {string} address - The original address
 * @param {string} networkId - The network ID
 * @returns {Object} - Transformed address, tradeSubAddress, and subTitle
 */
export function transformAddress(address, networkId) {
  const secondDefault = '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee';
  let tradeSubAddress;
  if (address === '1nc1nerator11111111111111111111111111111111') {
    address = SOLANA_NATIVE_ADDRESS;
    tradeSubAddress = SOLANA_NATIVE_ADDRESS;
  } else if ((address === defaultAddress || address === secondDefault) && addressMappings[Number(networkId)]) {
    address = addressMappings[Number(networkId)].address;
    tradeSubAddress = NATIVE_ADDRESS;
    networkId = Number(networkId) === ChainId.BASE || Number(networkId) === ChainId.ETHEREUM || Number(networkId) === ChainId.OPTIMISM || Number(networkId) === ChainId.ARBITRUM ? '1' : networkId;
  }
  return {
    address,
    tradeSubAddress,
    networkId
  };
}
export function haveDetails(tokenItem) {
  if (!(tokenItem === null || tokenItem === void 0 ? void 0 : tokenItem.address)) return false; // Ensure tokenItem has an address to validate
  const tokenAddressMap = {
    BTC: wBTCAddresses,
    LINK: ChainLinkAddresses,
    ETH: EthAddresses,
    USDT: StableTokenAddresses.Usdt,
    DAI: StableTokenAddresses.Dai,
    USDC: StableTokenAddresses.Usdc
  };
  // Iterate over all token categories
  for (const key in tokenAddressMap) {
    const tokenAddresses = tokenAddressMap[key];
    for (const networkKey in tokenAddresses) {
      const {
        address,
        network
      } = tokenAddresses[networkKey];
      if (address.toLowerCase() === tokenItem.address.toLowerCase() && (Array.isArray(tokenItem.networkId) ? tokenItem.networkId.includes(network) : tokenItem.networkId === network)) {
        return true;
      }
    }
  }
  return false;
}
export function isNativeTokenAddress(address) {
  var _a;
  // Check against constants
  if (address === SOLANA_NATIVE_ADDRESS || address === NATIVE_ADDRESS || address === defaultAddress || address === SOLANA_NATIVE_SIMPLE) {
    return true;
  }
  // Check against address mappings
  for (const chainId in addressMappings) {
    if (((_a = addressMappings[chainId].address) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === (address === null || address === void 0 ? void 0 : address.toLowerCase())) {
      return true;
    }
  }
  return false;
}